import { Table } from "antd";
import React from "react";
import CustomLinkButton from "../d-reusable/CustomLinkButton";
import CustomCard from "../d-reusable/CustomCard";
import {
  dentalBasePath,
  formateDateAndTime,
  getProjectCode,
  renderProjectStatusTextAndBgColor,
} from "../../../helper";
import { Link, useNavigate } from "react-router-dom";
import CustomPrimaryButton from "../d-reusable/CustomPrimaryButton";

const RecentProjects = ({ data }) => {
  const navigate = useNavigate();

  return (
    <CustomCard>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "20px 10px",
        }}
      >
        <h6
          style={{
            padding: 0,
            margin: 0,
            fontSize: 18,
            fontFamily: "Poppins-Medium",
          }}
        >
          Recent Projects
        </h6>
        <CustomPrimaryButton
          title={"View All"}
          onClick={() => navigate(`${dentalBasePath}/projects`)}
        />
      </div>
      <Table
        dataSource={data}
        columns={[
          {
            title: "Project Code",
            key: "identifier",
            render: (text, record) => getProjectCode(record.id),
          },
          {
            title: "Project Name",
            dataIndex: "title",
            key: "title",
          },
          {
            title: <div className="custom_header_col">Total Cases</div>,
            key: "total_am_cases",
            render: (text, record, index) => (
              <div className="center_align_digits">
                {record?.total_am_cases + record?.total_pm_cases}
              </div>
            ),
          },
          {
            title: <div className="custom_header_col">Date Created</div>,
            key: "created_at",
            render: (text, record, index) => (
              <div className="center_align_digits">
                {formateDateAndTime(record?.created_at)}
              </div>
            ),
          },
          {
            title: <div className="custom_header_col">Last Updated Date</div>,
            key: "updated_at",
            render: (text, record, index) => (
              <div className="center_align_digits">
                {" "}
                {formateDateAndTime(record?.updated_at)}
              </div>
            ),
          },
          {
            title: <div className="custom_header_col">Collaborated</div>,
            key: "is_collaborated",
            render: (text, record, index) => (
              <div className="center_align_digits">
                {record?.is_collaborated === 0 ? "No" : "Yes"}
              </div>
            ),
          },
          {
            title: <div className="custom_header_col">Status</div>,
            key: "status",
            render: (text, record) => {
              const bgColor = renderProjectStatusTextAndBgColor(record?.status);

              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      display: "inline-block",
                      background: bgColor,
                      padding: "1px 10px",
                      textAlign: "center",
                      borderRadius: 10,
                      color: "#FFFFFF",
                      textTransform: "capitalize",
                      fontSize: 12,
                      fontFamily: "Poppins-Regular",
                      fontWeight: "500",
                    }}
                  >
                    {record.status === "open" ? "Active" : record.status}
                  </div>
                </div>
              );
            },
          },
          {
            title: <div className="custom_header_col">Action</div>,
            dataIndex: "action",
            key: "action",
            render: (text, record) => {
              return (
                <div
                  onClick={() =>
                    navigate(`${dentalBasePath}/projects/details`, {
                      state: { projectId: record.id },
                    })
                  }
                  className="center_align_digits"
                  style={{
                    color: "#20C3FF",
                    fontSize: 14,
                    fontFamily: "Poppins-Medium",
                    cursor: "pointer",
                  }}
                >
                  View Details
                </div>
              );
            },
          },
        ]}
        pagination={false}
        style={{ height: "400px", overflowX: "scroll" }}
      />
    </CustomCard>
  );
};

export default RecentProjects;
